// Wires a slider-section's header controls (dots + prev/next arrows)
// to an Embla instance. The markup lives in _partials/slider-section.twig;
// dots are generated here from scrollSnapList() since the snap count
// depends on slides-per-view and changes on resize.
export class SliderControls {
	constructor({ embla, element }) {
		this.embla = embla
		this.element = element

		if (!this.embla || !this.element) return

		this.elPagination = this.element.querySelector('.js-slider-pagination')
		this.elBtnPrev = this.element.querySelector('.js-slider-prev')
		this.elBtnNext = this.element.querySelector('.js-slider-next')

		this.init()
	}
	init() {
		if (this.elBtnPrev) {
			this.bndOnPrevClick = this.onPrevClick.bind(this)
			this.elBtnPrev.addEventListener('click', this.bndOnPrevClick)
		}

		if (this.elBtnNext) {
			this.bndOnNextClick = this.onNextClick.bind(this)
			this.elBtnNext.addEventListener('click', this.bndOnNextClick)
		}

		if (this.elPagination) {
			this.bndOnPaginationClick = this.onPaginationClick.bind(this)
			this.elPagination.addEventListener('click', this.bndOnPaginationClick)

			this.bndInitPagination = this.initPagination.bind(this)
			this.embla.on('resize', this.bndInitPagination)

			this.bndUpdatePagination = this.updatePagination.bind(this)
			this.embla.on('select', this.bndUpdatePagination)

			this.initPagination()
		}

		// snap count changes on resize (slides-per-view), so keep re-checking
		this.bndUpdateVisibility = this.updateVisibility.bind(this)
		this.embla.on('resize', this.bndUpdateVisibility)

		this.updateVisibility()
	}
	updateVisibility() {
		this.element.classList.toggle('is-hidden', this.embla.scrollSnapList().length <= 1)
	}
	initPagination() {
		this.elPagination.innerHTML = ''
		this.paginationButtons = []

		const nrOfSnaps = this.embla.scrollSnapList().length

		if (nrOfSnaps <= 1) return

		for (let i = 0; i < nrOfSnaps; i++) {
			const elDot = document.createElement('button')
			elDot.type = 'button'
			elDot.classList.add('slider-pagination__dot')
			elDot.setAttribute('aria-label', `Ga naar slide ${i + 1}`)
			this.elPagination.appendChild(elDot)
		}

		this.paginationButtons = Array.from(this.elPagination.children)

		this.updatePagination()
	}
	updatePagination() {
		const index = this.embla.selectedScrollSnap()

		this.paginationButtons.forEach((el, i) => {
			el.classList.toggle('is-active', i === index)
		})
	}
	onPaginationClick(ev) {
		const elBtn = ev.target.closest('button')

		if (!elBtn) return

		this.embla.scrollTo(this.paginationButtons.indexOf(elBtn))
	}
	// Embla falls back to loop: false when there aren't enough slides
	// to loop safely, so wrap around manually at the edges.
	onPrevClick(ev) {
		ev.preventDefault()

		if (this.embla.canScrollPrev()) {
			this.embla.scrollPrev()
		} else {
			this.embla.scrollTo(this.embla.scrollSnapList().length - 1)
		}
	}
	onNextClick(ev) {
		ev.preventDefault()

		if (this.embla.canScrollNext()) {
			this.embla.scrollNext()
		} else {
			this.embla.scrollTo(0)
		}
	}
	destroy() {
		if (!this.embla || !this.element) return

		if (this.elBtnPrev) {
			this.elBtnPrev.removeEventListener('click', this.bndOnPrevClick)
		}
		if (this.elBtnNext) {
			this.elBtnNext.removeEventListener('click', this.bndOnNextClick)
		}
		if (this.elPagination) {
			this.elPagination.removeEventListener('click', this.bndOnPaginationClick)
			this.embla.off('resize', this.bndInitPagination)
			this.embla.off('select', this.bndUpdatePagination)
			this.elPagination.innerHTML = ''
		}

		this.embla.off('resize', this.bndUpdateVisibility)
	}
}
